import { useContext } from "react";
import { CourseContext } from "contexts";

export default () => useContext(CourseContext);
